export enum ContentDefineType {
  TermsOfUse = "TERMS_OF_USE", //Điêu khoản sử dụng
  Faq = "FAQ", //Câu hỏi thường gặp
  Hotline = "HOT_LINE",
  About = "ABOUT", //giới thiệu
  DeliveryPolicy = "DELIVERY_POLICY", //Chính sách đổi trả hàng
  Policy = "POLICY", //Chính sách & quy định
  MerchantPolicy = "MERCHANT_POLICY",
}

export const ContentDefineTypeTrans = {
  [ContentDefineType.TermsOfUse]: "Điều khoản sử dụng",
  [ContentDefineType.Faq]: "Các câu hỏi thường gặp",
  [ContentDefineType.Hotline]: "Hot line",
  [ContentDefineType.About]: "Giới thiệu",
  [ContentDefineType.DeliveryPolicy]: "Chính sách đổi trả hàng",
  [ContentDefineType.Policy]: "Chính sách & quy định",
  [ContentDefineType.MerchantPolicy]: "Chính sách thành viên",
};

export interface ContentDefine {
  id: number;
  createdAt: number;
  updatedAt: number;
  isDeleted: boolean;
  body: string;
  type: ContentDefineType;
}
